import { render, staticRenderFns } from "./PaymentStatement.vue?vue&type=template&id=2426ccd8&scoped=true"
import script from "./PaymentStatement.vue?vue&type=script&lang=js"
export * from "./PaymentStatement.vue?vue&type=script&lang=js"
import style0 from "./PaymentStatement.vue?vue&type=style&index=0&id=2426ccd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2426ccd8",
  null
  
)

export default component.exports